import { render, staticRenderFns } from "./EmailConfirmationAlert.vue?vue&type=template&id=a152ac26&scoped=true&"
import script from "./EmailConfirmationAlert.vue?vue&type=script&lang=js&"
export * from "./EmailConfirmationAlert.vue?vue&type=script&lang=js&"
import style0 from "./EmailConfirmationAlert.vue?vue&type=style&index=0&id=a152ac26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a152ac26",
  null
  
)

export default component.exports